import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1qwx4f5-0' })`
    display: flex;
    align-items: center;
    color: var(--c-input-error-text);
    font-size: ${(props) => props.theme.font.size.small};
    line-height: 1.2;
    margin-top: ${size(0.5)};
`;

export const Icon = styled.div.withConfig({ componentId: 'sc-1qwx4f5-1' })`
    flex-shrink: 0;
    padding-right: ${size(1)};
`;

export const Text = styled.div.withConfig({ componentId: 'sc-1qwx4f5-2' })`
    flex: 1 1 auto;
`;
